import {
  Box,
  Card,
  CardContent,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import MainCard from "ui-component/cards/MainCard";
import TotalAlumniCountCard from "./TotalAlumniCountCard";
import SubCard from "ui-component/cards/SubCard";
import SearchAlumni from "./SearchAlumni";
import EventCard from "./EventCard";
import useRequestIdGenerater from "customhooks";
import useTimeStamp from "reuseableTable/uniquetimestamp/GenerateUniqueTimeStamp";
import axios from "axios";
import PostCard from "./PostDetailsCard";
import TotalPendingMembers from "./TotalPendingMembers";
import TableView from "../instituteDashboard/TableView";
import ApartmentIcon from "@mui/icons-material/Apartment";
import PaddingIcon from "@mui/icons-material/Padding";
import Map from "views/application/map";
import CreatePost from "views/application/users/social-profile/CreatePost";
import { gridSpacing } from "store/constant";
import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";
import AnimatedLoader from "reuseableTable/AnimatedLoader";
import { EditOutlined } from "@mui/icons-material";

const NewDashboard = () => {
  const [allPostList, setAllPostList] = useState([]);
  const [getlastdata, setLastdata] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);

  const [totalAlumniCount, setTotalAlumniCount] = useState(0);
  const [totalPendingCount, setTotalPendingCount] = useState(0);
  const [countByOragnization, setCountByOragnization] = useState([]);
  const [countByDesigination, setCountByDesigination] = useState([]);
  const [countByCareerStatus, setCountByCareerStatus] = useState([]);

  const [upcomingEvent, setUpComingEvent] = useState([]);
  const [view, setView] = useState("all");
  const [liveUpdateList, setLiveUpdateList] = useState([]);

  const [branchList, setBranchList] = useState([]);
  const [branchId, setBranchId] = useState("");
  const branchAdmin = localStorage.getItem("branchAdmin") === "true";

  const RequestId = useRequestIdGenerater();
  const { rendomRequestId, generateTimeStamp } = useTimeStamp();

  const handleToggle = (event, newView) => {
    setLastdata(false);
    if (newView !== null && newView !== view) {
      setView(newView);
      setPageNumber(0); // Reset pagination when changing view
      setAllPostList([]); // Clear previous data
    }
  };
  // const transformDataWithNameKey = (data, keyName) => {
  //   return data.map((item) => ({
  //     name: item[keyName],
  //     count: item.count,
  //   }));
  // };
  const transformDataWithNameKey = (data, keyName) => {
    return data
      .filter((item) => item[keyName]) // filters out null, undefined, and empty string
      .map((item) => ({
        name: item[keyName],
        count: item.count,
      }));
  };

  const getDashboardData = async () => {
    try {
      const response = await axios.get(`/v1/dashboard/count`, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem(
            "serviceToken"
          )}`,
          "Content-Type": "application/json",
          requestId: RequestId(
            Math.floor(1000 + Math.random() * 9999),
            Math.floor(1000 + Math.random() * 9999 + rendomRequestId)
          ),
        },
      });
      setTotalAlumniCount(response?.data?.data?.totalAlumniCount);
      setTotalPendingCount(response?.data?.data?.pendingMemberCount);

      const organizationtransformedData = transformDataWithNameKey(
        response?.data?.data?.alumniCountByOrganizations,
        "organizationName"
      );
      setCountByOragnization(organizationtransformedData);

      const DesignationtransformedData = transformDataWithNameKey(
        response?.data?.data?.alumniCountByDesignations,
        "designationName"
      );
      setCountByDesigination(DesignationtransformedData);

      generateTimeStamp();
    } catch (err) {
      generateTimeStamp();
      console.log(err);
    }
  };
  const handleUpdatePostLikes = (updatedPost) => {
    const updatedPosts = allPostList?.map((post) => {
      if (post.id === updatedPost.id) {
        return updatedPost;
      } else {
        return post;
      }
    });
    setAllPostList(updatedPosts);
  };
  const handleUpdatePostLikesWS = (updatedPost) => {
    setAllPostList((prevPosts) => {
      return prevPosts.map((post) => {
        if (post.id === updatedPost.id) {
          return {
            ...post,
            likes: updatedPost.likes,
            postLikesIds: updatedPost.postLikesIds,
            reactionCount: updatedPost.reactionCount,
          };
        } else {
          return post;
        }
      });
    });
  };

  useEffect(() => {
    const token = window.localStorage.getItem("serviceToken");

    const client = new Client({
      brokerURL: "ws://https://dpsapi.alumni.live/ws",
      webSocketFactory: () => new SockJS("https://dpsapi.alumni.live/ws"),
      connectHeaders: {
        Authorization: `Bearer ${token}`,
      },
      debug: function (str) {
        console.log(str);
      },
      reconnectDelay: 5000,
      heartbeatIncoming: 4000,
      heartbeatOutgoing: 4000,
    });

    client.onConnect = () => {
      client.subscribe("/topic/posts", (message) => {
        const updatedPost = JSON.parse(message.body);
        handleUpdatePostLikesWS(updatedPost);
      });
    };

    client.activate();

    return () => {
      client.deactivate();
    };
  }, []);
  const getPostDetails = useCallback(
    async (currentView, currentPage, branch) => {
      setIsLoading(true);
      try {
        const reported = currentView === "reported" ? "&reported=true" : "";
        const response = await axios.get(
          `/v1/posts/all?pageSize=10&pageNumber=${currentPage}${reported}&branchId=${branch || branchId || ""
          }`,
          {
            headers: {
              Authorization: `Bearer ${window.localStorage.getItem(
                "serviceToken"
              )}`,
              "Content-Type": "application/json",
              requestId: RequestId(
                Math.floor(1000 + Math.random() * 9999),
                Math.floor(1000 + Math.random() * 9999 + rendomRequestId)
              ),
            },
          }
        );

        setAllPostList((prev) =>
          currentPage === 0
            ? response?.data?.data?.content || []
            : [...prev, ...(response?.data?.data?.content || [])]
        );
        setLastdata(response?.data?.data?.last);
      } catch (err) {
        console.error("Error fetching posts:", err);
      } finally {
        setIsLoading(false);
        generateTimeStamp();
      }
    },
    []
  );

  const getLiveProfileUpdateData = async () => {
    try {
      const response = await axios.get(`/v1/dashboard/alumni-live-updates`, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem(
            "serviceToken"
          )}`,
          "Content-Type": "application/json",
          requestId: RequestId(
            Math.floor(1000 + Math.random() * 9999),
            Math.floor(1000 + Math.random() * 9999 + rendomRequestId)
          ),
        },
      });

      setLiveUpdateList(response?.data?.data);
      generateTimeStamp();
    } catch (err) {
      generateTimeStamp();
      console.log(err);
    }
  };
  const getCountByCareerStatus = async () => {
    try {
      const response = await axios.get(`/v1/alumni/count-by-career-status`, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem(
            "serviceToken"
          )}`,
          "Content-Type": "application/json",
          requestId: RequestId(
            Math.floor(1000 + Math.random() * 9999),
            Math.floor(1000 + Math.random() * 9999 + rendomRequestId)
          ),
        },
      });

      const careerData = response?.data?.data;
      const CareerStatusResponse = transformDataWithNameKey(
        response?.data?.data,
        "id"
      );
      setCountByCareerStatus(CareerStatusResponse);

      // calculate total count
      const totalCount = careerData.reduce((acc, item) => acc + item.count, 0);
      console.log("Total Count:", totalCount);

      generateTimeStamp();
    } catch (err) {
      generateTimeStamp();
      console.log(err);
    }
  };

  const getEventList = async () => {
    try {
      const response = await axios.get(`/v1/event/institute/upcoming/event`, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem(
            "serviceToken"
          )}`,
          "Content-Type": "application/json",
          requestId: RequestId(
            Math.floor(1000 + Math.random() * 9999),
            Math.floor(1000 + Math.random() * 9999 + rendomRequestId)
          ),
        },
      });

      setUpComingEvent(response?.data?.data);
      generateTimeStamp();
    } catch (err) {
      generateTimeStamp();
      console.log(err);
    }
  };

  const handleScroll = () => {
    const { scrollTop, clientHeight, scrollHeight } = document.documentElement;
    if (scrollTop + clientHeight >= scrollHeight - 5 && !isLoading) {
      setPageNumber((prevPageNumber) => prevPageNumber + 1);
    }
  };
  const getRole = localStorage.getItem("role");

  const fetchData = async (endpoint, processResponse) => {
    let url = `/v1/${endpoint}`;
    const instituteId =
      getRole === "ROLE_SUPER_ADMIN" ? localStorage.getItem("instituteId") : "";

    if (instituteId) {
      url += `?instituteId=${instituteId}`;
    }

    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem(
            "serviceToken"
          )}`,
          "Content-Type": "application/json",
          requestId: RequestId(
            Math.floor(1000 + Math.random() * 9999),
            Math.floor(1000 + Math.random() * 9999 + rendomRequestId)
          ),
        },
      });

      processResponse(response);
      generateTimeStamp();
    } catch (err) {
      console.log(err);
      generateTimeStamp();
    }
  };

  const getBranchList = () => {
    if (branchAdmin) return;
    fetchData("institute-branch/page?pageNumber=0&pageSize=100", (response) => {
      setBranchList(response?.data?.data?.content);
    });
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (!getlastdata) {
      getPostDetails(view, pageNumber, branchId);
    }
    generateTimeStamp();
  }, [pageNumber, view, branchId]);

  useEffect(() => {
    getBranchList();
    getLiveProfileUpdateData();
    getDashboardData();
    getCountByCareerStatus();
    getEventList();
  }, []);

  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  return (
    <>
      <Grid container spacing={1}>
        <Grid item md={3} lg={3} xs={12}>
          <TotalAlumniCountCard count={totalAlumniCount} />
          <Grid container sx={{ mt: 1 }} spacing={1}>
            <Grid item md={12} xs={12} lg={12}>
              <TotalPendingMembers color="#3AC33D" count={totalPendingCount} />
            </Grid>

            <Grid item md={12} xs={12} lg={12}>
              <TableView
                color="#3ac33d"
                icon={<PaddingIcon />}
                list={countByCareerStatus}
                titleName="Career Status"
              />
            </Grid>

            <Grid item md={12} xs={12} lg={12}>
              <TableView
                color="#d4a9f2"
                icon={<ApartmentIcon />}
                list={countByOragnization}
                titleName="Organization"
                type="Organization"
              />
            </Grid>
            <Grid item md={12} xs={12} lg={12}>
              <TableView
                color="#3ac33d"
                icon={<PaddingIcon />}
                list={countByDesigination}
                titleName="Designation"
                type="Designation"
              />
            </Grid>

            <Grid item md={12} xs={12} lg={12}>
              <SubCard
                sx={{ mt: 1 }}
                title={
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Typography sx={{ textAlign: "center", fontWeight: 500 }}>
                        Live Update
                      </Typography>
                      <div
                        style={{
                          height: "10px",
                          width: "10px",
                          background: "red",
                          borderRadius: "50%",
                          marginLeft: "5px",
                          animation: "live 2s linear infinite",
                        }}
                      ></div>
                      <style jsx global>{`
                        @keyframes live {
                          0% {
                            transform: scale(1);
                          }
                          50% {
                            transform: scale(1.5);
                          }
                          100% {
                            transform: scale(1);
                          }
                        }
                      `}</style>
                    </div>
                  </div>
                }
              >
                <SearchAlumni liveUpdateList={liveUpdateList} />
              </SubCard>

              <Card sx={{ mt: 1 }}>
                <CardContent>
                  <Typography sx={{ fontWeight: 600 }}>Events</Typography>
                </CardContent>
              </Card>
              <Grid
                sx={{
                  height: "400px",
                  overflow: "auto",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#B1F3BD",
                    borderRadius: "4px",
                  },
                  "&::-webkit-scrollbar-track": {
                    backgroundColor: "white",
                  },
                }}
              >
                {upcomingEvent?.length > 0 ? (
                  upcomingEvent.map((post) => (
                    <EventCard post={post} key={post.id} />
                  ))
                ) : (
                  <Card sx={{ mt: 1 }}>
                    <CardContent>
                      <Typography sx={{ fontWeight: 400 }}>
                        {" "}
                        There are no upcoming events at the moment.
                      </Typography>
                    </CardContent>
                  </Card>
                )}
              </Grid>
            </Grid>

            {/* <Grid item md={6} xs={6} lg={6}>
              <AlumniStatsCard
                count={13552}
                color="#3AC33D"
                label="Active Alumni"
                icon={<img src={ActiveAlumni} alt="total Alumni" />}
              />
            </Grid>
            <Grid item md={6} xs={6} lg={6}>
              <AlumniStatsCard
                count={13552}
                color="#3AC33D"
                label="Active Alumni"
                icon={<img src={ActiveAlumni} alt="total Alumni" />}
              />
            </Grid> */}
          </Grid>
          {/* <SubCard title="Approvals" sx={{ p: 0, mt: 1 }}>
            <ApprovalCard />
            <ApprovalCard />
          </SubCard> */}
        </Grid>

        {/* <Grid item md={5} lg={5} xs={12}>
          <Card>
            <CardContent>
              <Typography sx={{ fontWeight: 600 }}>Posts</Typography>
            </CardContent>
          </Card>
          <Grid>
            {allPostList.length === 0 ? (
              <Card sx={{ mt: 1 }}>
                <CardContent>
                  <Grid
                    item
                    md={12}
                    xs={12}
                    sx={{
                      textAlign: "center",
                      border: "1px solid #f6f6f6",
                      p: 5,
                    }}
                  >
                    <Typography>No Posts.</Typography>
                  </Grid>
                </CardContent>
              </Card>
            ) : (
              allPostList?.map((post) => (
                <Grid key={post.id} item xs={12}>
                  <PostCard
                    isLoading={isLoading}
                    // alumniDetails={alumniDetails}
                    post={post}
                    // setPosts={handleUpdatePostLikes}
                  />
                </Grid>
              ))
            )}
          </Grid>
        </Grid> */}

        <Grid item md={9} lg={9} xs={12}>
          <SubCard>
            <Map />
          </SubCard>

          <Card
            sx={{
              mt: 2,
              borderRadius: 2,
              boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.08)",
            }}
          >
            <CardContent
              sx={{
                p: 2,
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                alignItems: { xs: "flex-start", sm: "center" },
                justifyContent: "space-between",
                gap: 2,
              }}
            >
              {/* Title */}
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 600,
                  color: "text.primary",
                  flexShrink: 0,
                }}
              >
                {view === "all" ? "All Posts" : "Reported Posts"}
              </Typography>

              {/* Filters Section */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  alignItems: "center",
                  gap: 2,
                  width: { xs: "100%", sm: "auto" },
                }}
              >
                {/* Branch Filter */}
                {branchList.length > 0 && (
                  <FormControl
                    sx={{
                      minWidth: 180,
                      width: { xs: "100%", sm: "auto" },
                    }}
                  >
                    <InputLabel id="branch-select-label">
                      Select Branch
                    </InputLabel>
                    <Select
                      labelId="branch-select-label"
                      id="institutionsBranchId"
                      size="small"
                      value={branchId}
                      onChange={(e) => {
                        setBranchId(e.target.value);
                        getPostDetails(10, 0, e.target.value);
                      }}
                      label="Select Branch"
                      sx={{
                        "& .MuiSelect-select": {
                          py: 1.2,
                        },
                      }}
                    >
                      <MenuItem value="">
                        <em>All Branches</em>
                      </MenuItem>
                      {branchList?.filter((elem) => elem?.status)?.map((data) => (
                        <MenuItem key={data.id} value={data.id}>
                          {data.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}

                {/* View Toggle */}
                <ToggleButtonGroup
                  value={view}
                  exclusive
                  onChange={handleToggle}
                  sx={{
                    borderRadius: 2,
                    "& .MuiToggleButton-root": {
                      px: 2,
                      py: 1,
                      border: "1px solid",
                      borderColor: "primary.main",
                      color: "primary.main",
                      textTransform: "none",
                      fontWeight: 500,
                      "&:hover": {
                        bgcolor: "primary.lighter",
                      },
                    },
                    "& .MuiToggleButton-root.Mui-selected": {
                      bgcolor: "primary.main",
                      color: "common.white",
                      "&:hover": {
                        bgcolor: "primary.dark",
                      },
                    },
                  }}
                >
                  <ToggleButton value="all" aria-label="All posts">
                    All Posts
                  </ToggleButton>
                  <ToggleButton value="reported" aria-label="Reported posts">
                    Reported Posts
                  </ToggleButton>
                </ToggleButtonGroup>
              </Box>
            </CardContent>

            {/* Create Post Field */}
            <Box sx={{ px: 2, pb: 2 }}>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="What's on your mind?"
                onClick={handleClickOpen}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                    backgroundColor: "action.hover",
                    "&:hover": {
                      backgroundColor: "action.selected",
                    },
                  },
                  "& .MuiOutlinedInput-input": {
                    py: 1.5,
                    cursor: "pointer",
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EditOutlined color="action" />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>

            {/* Create Post Dialog */}
            <CreatePost
              view={view}
              setIsLoading={setIsLoading}
              setPosts={setAllPostList}
              getPostDetails={getPostDetails}
              setPageNumber={setPageNumber}
              alumniDetails={[]}
              setOpen={setOpen}
              open={open}
            />
          </Card>
          <Grid>
            {isLoading ? (
              <Grid
                item
                xs={12}
                style={{ textAlign: "center", padding: "2rem" }}
              >
                <AnimatedLoader />
              </Grid>
            ) : (
              <>
                {allPostList.length === 0 ? (
                  <Card sx={{ mt: 1 }}>
                    <CardContent>
                      <Grid
                        item
                        md={12}
                        xs={12}
                        sx={{
                          textAlign: "center",
                          border: "1px solid #f6f6f6",
                          p: 5,
                        }}
                      >
                        <Typography>No Posts.</Typography>
                      </Grid>
                    </CardContent>
                  </Card>
                ) : (
                  allPostList?.map((post) => (
                    <Grid key={post.id} item xs={12}>
                      <PostCard
                        view={view}
                        setPageNumber={setPageNumber}
                        pageNumber={pageNumber}
                        isLoading={isLoading}
                        // alumniDetails={alumniDetails}
                        post={post}
                        setPosts={handleUpdatePostLikes}
                        getPostDetails={getPostDetails}
                      />
                    </Grid>
                  ))
                )}
              </>
            )}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default NewDashboard;
